import React from 'react';

// Где игрок в фазе банов: подтвердил свои баны, еще выбирает или не банит
// вовсе (бот со значком, ИИ промо-матча — см. checkIfFactionBanVoter)
export const LOBBY_BAN_STATUSES = {
  CONFIRMED: 'confirmed',
  CHOOSING: 'choosing',
  NOT_VOTING: 'not_voting',
};

const BAN_STATUS_LABELS = {
  [LOBBY_BAN_STATUSES.CONFIRMED]: 'Подтвердил баны',
  [LOBBY_BAN_STATUSES.CHOOSING]: 'Выбирает баны',
  [LOBBY_BAN_STATUSES.NOT_VOTING]: 'Не банит',
};

// На телефоне метка стоит в одной строке с ником и тремя другими бейджами —
// длинные подписи съедают ник: «Подтвердил баны» шириной 141 px на экране
// 360 px оставляла нику в своей строке (рядом с «Создатель» и «Вы») 3 px
const BAN_STATUS_COMPACT_LABELS = {
  ...BAN_STATUS_LABELS,
  [LOBBY_BAN_STATUSES.CONFIRMED]: 'Подтвердил',
  [LOBBY_BAN_STATUSES.CHOOSING]: 'Банит',
};

const BAN_STATUS_TITLES = {
  [LOBBY_BAN_STATUSES.CONFIRMED]: 'Игрок подтвердил свои баны',
  [LOBBY_BAN_STATUSES.CHOOSING]: 'Игрок еще не подтвердил свои баны',
  [LOBBY_BAN_STATUSES.NOT_VOTING]: 'Этот игрок фракции не банит',
};

/**
 * Метка игрока лобби на время фазы банов — рядом с остальными бейджами
 * (Оффлайн, Создатель, Готов). Вне фазы (status null) не рисуется.
 *
 * @param {Object} props
 * @param {string|null} props.status - значение LOBBY_BAN_STATUSES
 * @param {string} [props.className]
 * @param {boolean} [props.isCompact] - короткие подписи (мобильная плашка)
 */
const LobbyBanStatusBadge = ({status, className = '', isCompact = false}) => {
  if (!status || !BAN_STATUS_LABELS[status]) {
    return null;
  }
  return (
    <span
      className={`lobby-ban-status-badge lobby-ban-status-badge_${status} ${className}`.trim()}
      title={BAN_STATUS_TITLES[status]}
    >
      {(isCompact ? BAN_STATUS_COMPACT_LABELS : BAN_STATUS_LABELS)[status]}
    </span>
  );
};

export default LobbyBanStatusBadge;
